export const SELECTED_ORG_ID = 'selectedOrganisationId';
export const SELECTED_ORG_NAME = 'selectedOrganisationName';
/** Comma-separated org IDs, most recently viewed first (max 10). */
export const RECENT_ORG_IDS = 'recentOrganisationIds';
/** JSON array of society objects from the public /search hero (max 5). */
export const RECENTLY_VIEWED_ORGS = 'recentlyViewedOrgs';
/** Pending invite identifier, captured before login completes. */
export const INVITE_GUID = 'invite-guid';
/** Public-search animal result display preference (e.g. list/grid). */
export const RESULT_DISPLAY = 'resultDisplay';
/** MSAL environment identifier — used to detect tenant changes. */
export const MSAL_ENVIRONMENT = 'msal-environment';
/** Shell config-menu open state. */
export const CONFIG_MENU_OPEN = 'configMenuOpen';
/** Shell sidebar expanded state. */
export const SIDEBAR_EXPANDED = 'sidebarExpanded';
